/*------------------------------------------------*/
/* LIBRARIES
/*------------------------------------------------*/
import React, { PureComponent } from 'react';
import { Provider } from 'react-redux';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import 'notyf/notyf.min.css';

/*------------------------------------------------*/
/* INTERNAL DEPENDENCIES
/*------------------------------------------------*/
// Components
import FormList from './FormList/containers/formList';
import FormEditor from './FormEditor/containers/formEditor';
import FormClient from './FormClient/containers/formClient';
import Notificator from './common/notificator';
// Constants
import { ROUTES } from './common/globals';
// Redux
import configureStore from './stores/rootStore';
import workastDataActions from './stores/WorkastData/actions';
// Styles
import './App.css';

class App extends PureComponent {
  constructor(props) {
    super(props);
    
    this.store = configureStore();
    this.store.dispatch(workastDataActions.setInitialData(props.data));

    this.formViewerRegex = /\/form\/[a-f\d]{24}$/;
  }

  render() {
    const {
      data
    } = this.props;
    
    const { token } = data;
    
    return (
      <div className="App container-fluid">
        <Router>
          <Provider store={this.store}>
            <Switch>
              <Route
                exact
                path={ROUTES.BASE}
                component={() => {
                  const path = window.location.pathname;
                  const isClient = this.formViewerRegex.test(path);
                  if (isClient) {
                    const formId = path.split('/')[2];
                    return <FormClient formId={formId} token={token} />;
                  }
  
                  return <FormList token={token} />;
                }}
              />
              <Route
                path={ROUTES.EDIT}
                component={(routerProps) => {
                  const {
                    formId
                  } = routerProps.match.params;
                
                  return <FormEditor formId={formId} token={token} />;
                }}
              />
            </Switch>
            <Notificator />
          </Provider>
        </Router>
      </div>
    );
  }
}

App.propTypes = {
  data: PropTypes.shape({
    token: PropTypes.string.isRequired,
    user: PropTypes.any,
    form: PropTypes.any,
    forms: PropTypes.array
  }).isRequired
};
export default App;
